import React, { useCallback, useEffect, useMemo } from "react";
import { Dropdown, Button, Badge, Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewCountryList } from "../../Redux/Actions/settingsActions";
import { useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";

const ListCountryState = () => {
  const [searchQuery, setQuerySearch] = useState("");

  const columns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Country Name",
      dataIndex: "country_name",
      align: "center",
      key: "country_name_withoutspace",
    },
    {
      title: "Country Code",
      dataIndex: "country_code",
      align: "center",
      key: "country_code",
    },
    {
      title: "Country's Language",
      dataIndex: "country_language_name",
      key: "country_language_name",
      align: "center",
    },
    {
      title: "Language Code",
      dataIndex: "country_language_code",
      key: "country_language_code",
      align: "center",
    },
    {
      title: "Country's Currency",
      dataIndex: "country_currency",
      key: "country_currency",
      align: "center",
    },
    {
      title: "Currency's Symbol",
      dataIndex: "country_currency_symbol",
      key: "country_currency_symbol",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (status) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9",
            borderRadius: "10px",
          }}
        >
          <Badge
            color={status === "active" ? "green" : "red"}
            text={status.charAt(0).toUpperCase() + status.slice(1)}
          />
        </span>
      ),
    },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="view">
                <Link to={`/state-list/${record._id}`}>View States</Link>
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    },
  ];

  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchCountryDetails = useCallback(
    (page, pageSize) => {
      const countryData = {
        page,
        limit: pageSize,
      };
      dispatch(viewCountryList(countryData));
    },
    [dispatch]
  );

  const { loading, countryList } = useSelector((state) => state.country); // fetching the state country from the redux store

  useEffect(() => {
    fetchCountryDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchCountryDetails]);

  useEffect(() => {
    if (countryList?.total) {
      setPagination((prevData) => ({ ...prevData, total: countryList.total }));
    }
  }, [countryList]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchCountryDetails(pagination.current, pagination.pageSize);
  };

  const filteredCountries = useMemo(
    () =>
      Array.isArray(countryList?.data)
        ? countryList.data.filter((country) =>
            country.country_name.toLowerCase().includes(searchQuery)
          )
        : [],
    [countryList, searchQuery]
  );

  return (
    <TableComponent
      h3heading="Country List"
      buttonhead="Add Country"
      navigateTo="/country/add"
      setState={setQuerySearch}
      columns={columns}
      dataSource={filteredCountries}
      onChange={handleTableChange}
      style={{ fontFamily: "Gilroy-SemiBold" }}
      loading={loading}
    ></TableComponent>
  );
};

export default ListCountryState;
